var g = Object.defineProperty;
var v = (d, t, e) => t in d ? g(d, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : d[t] = e;
var h = (d, t, e) => (v(d, typeof t != "symbol" ? t + "" : t, e), e);
class E {
  /**
   * Creates an instance of Tooltip.
   * @param {HTMLElement} element - The DOM element that contains the tooltip.
   * @param {Object} userConfig
   * @param {string} [userConfig.blockClass='tooltip'] - The class name of the tooltip BEM-Block.
   * @memberof Tooltip
   */
  constructor(t, e) {
    /**
     * Initialize the tooltip.
     *
     * @public
     */
    h(this, "init", () => {
      !this.element || !this.contentSelector || (this.createTooltip(), this.bindEvents());
    });
    /**
     * Destroy the tooltip.
     *
     * @public
     */
    h(this, "destroy", () => {
      this.unbindEvents(), this.destroyTooltip();
    });
    /**
     * Binds the necessary events for the Tooltip component.
     */
    h(this, "bindEvents", () => {
      this.element && (this.element.addEventListener("mouseenter", this.hasCursorHandler.bind(this)), this.element.addEventListener("mouseleave", this.lostCursorHandler.bind(this)), this.element.addEventListener("focusin", this.hasCursorHandler.bind(this)), this.element.addEventListener("focusout", this.lostCursorHandler.bind(this))), this.element && this.preventNativeTooltip && (this.element.addEventListener("mouseenter", this.preventNativeTooltipHandler), this.element.addEventListener("mouseleave", this.preventNativeTooltipHandler)), this.tooltipElement && (this.tooltipElement.addEventListener("mouseout", this.lostCursorHandler.bind(this)), window.addEventListener("resize", this.updatePosition.bind(this)));
    });
    h(this, "unbindEvents", () => {
      this.element && (this.element.removeEventListener("mouseenter", this.hasCursorHandler), this.element.removeEventListener("mouseleave", this.lostCursorHandler), this.element.removeEventListener("focusin", this.hasCursorHandler), this.element.removeEventListener("focusout", this.lostCursorHandler)), this.element && this.preventNativeTooltip && (this.element.removeEventListener("mouseenter", this.preventNativeTooltipHandler), this.element.removeEventListener("mouseleave", this.preventNativeTooltipHandler)), this.tooltipElement && this.tooltipElement.removeEventListener("mouseout", this.lostCursorHandler), window.removeEventListener("resize", this.updatePosition);
    });
    h(this, "createTooltip", () => {
      var a;
      const t = this.contentAttribute && ((a = this.element.querySelector(this.contentSelector)) == null ? void 0 : a.getAttribute(this.contentAttribute)) || this.contentAttribute && this.element.getAttribute(this.contentAttribute) || this.element.querySelector(this.contentSelector) || document.querySelector(this.contentSelector);
      if (!t)
        return;
      const e = typeof t != "string", i = e ? t.cloneNode(!0) : t;
      if (this.contentRemoveAttributes && e) {
        var s = i.getElementsByTagName("*");
        this.removeContentAttributes(i);
        for (let o = 0; o < s.length; o++)
          this.removeContentAttributes(s[o]);
      }
      this.originalTabIndex = this.element.tabIndex, this.targetIsFocusable && !(this.originalTabIndex >= 0) && this.element.setAttribute("tabindex", 0), this.tooltipElement = document.createElement("div"), this.tooltipElement.classList.add(this.blockClass), this.tooltipElement.setAttribute("role", "tooltip"), this.tooltipElement.setAttribute("aria-hidden", !0);
      const l = document.createElement("div");
      l.classList.add(`${this.blockClass}__inner`), this.tooltipPointerElement = document.createElement("div"), this.tooltipPointerElement.classList.add(`${this.blockClass}__pointer`), l.append(i), this.tooltipElement.append(l), this.tooltipElement.append(this.tooltipPointerElement), document.body.append(this.tooltipElement);
    });
    h(this, "destroyTooltip", () => {
      this.element && this.targetIsFocusable && !(this.originalTabIndex >= 0) && this.element.removeAttribute("tabindex"), this.tooltipElement && this.tooltipElement.remove();
    });
    h(this, "updatePosition", () => {
      this.tooltipElement && this.hasCursor && (this.resetPosition(), window.requestAnimationFrame(() => {
        var l, a;
        const t = this.getTargetPosition(), e = {}, i = {};
        e.width = (l = this.tooltipElement) == null ? void 0 : l.offsetWidth, e.height = (a = this.tooltipElement) == null ? void 0 : a.offsetHeight;
        const s = this.checkValidPosition(e, t);
        if (this.currentDirection = s.direction, this.tooltipElement.classList.add(`${this.blockClass}--${this.currentDirection}`), this.currentDirection === "top") {
          const o = t.top - e.height;
          let n = t.left + (t.width - e.width) / 2;
          this.tooltipAlignLeft && (n = t.left), this.tooltipAlignRight && (n = t.left + t.width - e.width), e.top = o, e.left = n, (s.leftTopBottomOverlap && s.rightOverlap || s.rightTopBottomOverlap && s.leftOverlap) && (s.isBreakingHorizontally = !0);
        }
        if (this.currentDirection === "bottom") {
          const o = t.bottom;
          let n = t.left + (t.width - e.width) / 2;
          this.tooltipAlignLeft && (n = t.left), this.tooltipAlignRight && (n = t.left + t.width - e.width), e.top = o, e.left = n, (s.leftTopBottomOverlap && s.rightOverlap || s.rightTopBottomOverlap && s.leftOverlap) && (s.isBreakingHorizontally = !0);
        }
        if (this.currentDirection === "left") {
          const o = t.top + (t.height - e.height) / 2, n = t.left - e.width;
          e.top = o, e.left = n;
        }
        if (this.currentDirection === "right") {
          const o = t.top + (t.height - e.height) / 2, n = t.right;
          e.top = o, e.left = n;
        }
        i.top = `${e.top}px`, i.left = `${e.left}px`, (s.isBreakingHorizontally || s.isBreakingVertically) && this.tooltipElement.classList.add(`${this.blockClass}--is-breaking`), (s.isBreakingHorizontally || e.left >= document.body.clientWidth || e.left < 0) && (i.left = "0", i.width = "100%", s.onLeftSide && (this.tooltipPointerElement.style.left = `${t.left}px`), s.onLeftSide || (this.tooltipElement.classList.add(`${this.blockClass}--is-breaking-right`), this.tooltipPointerElement.style.right = `${document.body.clientWidth - t.right}px`)), s.isBreakingVertically && (i.top = `${window.scrollY}px`), this.tooltipHasTargetMaxWidth && (i.maxWidth = `${t.width}px`), this.setTooltipStyles({
          ...i
        }), setTimeout(() => {
          this.isPositioned = !0, this.hasCursor && this.tooltipElement.classList.add(`${this.blockClass}--has-cursor`), this.hasCursor && !this.tooltipIsAriaHidden && this.tooltipElement.setAttribute("aria-hidden", !1);
        }, this.delay);
      }));
    });
    h(this, "checkValidPosition", (t, e) => {
      const i = document.body.clientWidth, s = document.body.clientHeight, l = e.left - t.width < 0, a = e.left + (e.width - t.width) / 2 < 0, o = e.right + t.width > i, n = e.left + (e.width - t.width) / 2 + t.width > i, c = e.y - t.height - this.stickyHeaderSafetyBuffer < 0, p = e.top + (e.height - t.height) / 2 - this.stickyHeaderSafetyBuffer < 0, f = e.y + e.height + t.height > s, u = e.top + e.height + (e.height - t.height) / 2 > s, m = e.left < i / 2;
      let r = {
        direction: this.currentDirection,
        isBreakingHorizontally: a && n,
        isBreakingVertically: p && u,
        topOverlap: c,
        rightOverlap: o,
        rightTopBottomOverlap: n,
        bottomOverlap: f,
        leftOverlap: l,
        leftTopBottomOverlap: a,
        onLeftSide: m
      };
      return o && !l && (r.direction = "left"), l && !o && (r.direction = "right"), c && !f && !a && !n && (r.direction = "bottom"), f && !c && !a && !n && (r.direction = "top"), c && a && !o && (r.direction = "right"), c && n && !l && (r.direction = "left"), f && a && !o && (r.direction = "right"), f && n && !l && (r.direction = "left"), l && o && !c && (r.direction = "top"), l && o && !f && (r.direction = "bottom"), !r[`${this.currentDirection}Overlap`] && !a && !n && (r.direction = this.currentDirection), l && o && c && (r.direction = "bottom"), r;
    });
    h(this, "getTargetPosition", () => {
      if (!this.element)
        return;
      const t = this.element.getBoundingClientRect(), e = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop;
      return {
        top: t.top + i,
        right: t.left + e + this.element.offsetWidth,
        bottom: t.top + i + this.element.offsetHeight,
        left: t.left + e,
        y: t.top,
        height: this.element.offsetHeight,
        width: this.element.offsetWidth
      };
    });
    /**
     * Set the appropriate inline-styles for tooltip.
     */
    h(this, "setTooltipStyles", (t) => {
      for (const [e, i] of Object.entries(t))
        this.tooltipElement.style[e] = `${i}`;
    });
    h(this, "removeContentAttributes", (t) => {
      const e = [];
      for (let i = 0; i < t.attributes.length; i++)
        e.push(t.attributes[i].name);
      for (let i = 0; i < e.length; i++)
        t.removeAttribute(e[i]);
    });
    /**
     * Activate tooltip.
     *
     * @public
     */
    h(this, "activate", () => {
      this.isActive = !0;
    });
    /**
     * Deactivate tooltip.
     *
     * @public
     */
    h(this, "deactivate", () => {
      this.isActive = !1, this.resetCursor(), this.resetPosition();
    });
    this.element = t, this.config = e || {}, this.contentSelector = this.config.contentSelector ?? (this.contentAttribute ? !1 : ".sr-only"), this.contentAttribute = this.config.contentAttribute ?? !1, this.tooltipElement = void 0, this.tooltipPointerElement = void 0, this.blockClass = this.config.blockClass ?? "tooltip", this.delay = this.config.delay ?? 600, this.stickyHeaderSafetyBuffer = this.config.stickyHeaderSafetyBuffer ?? 0, this.contentRemoveAttributes = this.config.contentRemoveAttributes ?? !0, this.tooltipIsAriaHidden = this.config.tooltipIsAriaHidden ?? !0, this.tooltipIsHoverable = this.config.tooltipIsHoverable ?? !0, this.tooltipAlignLeft = this.config.tooltipAlignLeft ?? !1, this.tooltipAlignRight = this.config.tooltipAlignRight ?? !1, this.tooltipHasTargetMaxWidth = this.config.tooltipHasTargetMaxWidth ?? !1, this.preventNativeTooltip = this.config.preventNativeTooltip ?? this.contentAttribute === "title", this.targetIsFocusable = this.config.targetIsFocusable ?? !0, this.isActive = !0, this.hasCursor = !1, this.isBreaking = !1, this.isPositioned = !1, this.isDisabled = this.config.disabled ?? !1, this.originalDirection = this.config.tooltipDirection ?? "top", this.currentDirection = this.originalDirection, this.originalTabIndex = void 0;
  }
  resetPosition() {
    this.isPositioned = !1, this.isBreaking = !1, this.tooltipElement.classList.remove(`${this.blockClass}--is-breaking`), this.tooltipElement.classList.remove(`${this.blockClass}--is-breaking-right`), this.setTooltipStyles({
      top: "",
      left: "",
      width: ""
    }), this.tooltipPointerElement.style.left = "", this.tooltipPointerElement.style.right = "", this.tooltipElement.classList.remove(`${this.blockClass}--${this.currentDirection}`), this.currentDirection = this.originalDirection;
  }
  keyupEscHandler(t) {
    !this.isActive || !(t.key === "Escape") || !this.hasCursor || this.tooltipElement && (this.isDisabled = !0, this.tooltipElement.classList.add(`${this.blockClass}--is-disabled`));
  }
  hasCursorHandler() {
    this.isActive && (this.isDisabled || (window.addEventListener("keyup", this.keyupEscHandler.bind(this)), this.hasCursor = !0, this.updatePosition()));
  }
  lostCursorHandler(t) {
    this.isActive && (this.tooltipIsHoverable && (t.relatedTarget === this.tooltipElement || this.tooltipElement.contains(t.relatedTarget)) || this.hasCursor && this.resetCursor());
  }
  resetCursor() {
    this.hasCursor = !1, this.tooltipElement.classList.remove(`${this.blockClass}--has-cursor`), this.isDisabled = !1, this.tooltipElement.classList.remove(`${this.blockClass}--is-disabled`), window.removeEventListener("keyup", this.keyupEscHandler), this.tooltipElement.setAttribute("aria-hidden", !0);
  }
  preventNativeTooltipHandler(t) {
    t.stopImmediatePropagation();
    const e = t.target.getAttribute("title"), i = t.target.dataset.tooltipTitle;
    if (e) {
      t.target.setAttribute("title", ""), t.target.setAttribute("data-tooltip-title", e);
      return;
    }
    t.target.setAttribute("title", i), t.target.setAttribute("data-tooltip-title", "");
  }
}
export {
  E as Tooltip
};
